import type {
  CompareType,
  Operator,
  RuleType
} from "../constants/rules.constants";

export type ConditionData = {
  id: string;
  firstCompareField: string;
  operator: Operator;
  __createdAt: number;
  __modifiedAt: number;
} & (
  | {
      // ensure that only one of the props is present, but not both
      secondCompareField: string;
      compareValue?: never;
    }
  | {
      secondCompareField?: never;
      compareValue: string;
    }
);

export type ConditionGroupData = {
  id: string;
  conditions: string[];
  groups: string[];
  compareType: CompareType;
  __createdAt: number;
  __modifiedAt: number;
};

/**
 * To hold all the conditions by their condition ID as key
 * and Condition data as value
 */
export type ConditionMap = Record<string, ConditionData>;

/**
 * To hold all the conditional groups, where group ID is the key
 * and the groupd details are the value
 */
export type ConditionGroupMap = Record<string, ConditionGroupData>;

export type RuleData = {
  id: string;
  conditions?: ConditionMap;
  groups?: ConditionGroupMap;
  actions: Record<string, any>;
  topLevelGroupId: string;
  name?: string;
  ruleType?: RuleType;
  ruleIndex?: number;
  isEnabled?: boolean;
  __targetFieldTag?: string;
  __newRule?: boolean;
  __modifiedAt: number;
  __createdAt: number;
};

export type RuleMap = Record<string, RuleData>;

export type Rule = Omit<RuleData, "conditions" | "groups"> & {
  ruleType?: RuleType;
  __targetFieldTag?: string;
  __modifiedAt: number;
};

export enum Direction {
  INCOMING = "incoming",
  OUTGOING = "outgoing"
}
